<template>
    <div class="warp">
      <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'协会动态发布审核',goback:true},{name:'协会动态发布审核详情'}]" :title="'协会动态发布审核详情'"/>
      <!-- 主体内容 -->
      <!-- 用户明细 -->
      <div class="box">
        <el-card class="basic box_card" header="账号信息" shadow="never">
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">账号：</div>
                <div class="content">{{ dataInfos.createUserName || '--' }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">账号类型：</div>
                <div class="content">{{ dataInfos.userType || '--' }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">姓名：</div>
                <div class="content">{{ dataInfos.realName || '--' }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">邮箱：</div>
                <div class="content">{{ dataInfos.mail || '--' }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="child">
                <div class="name">联系地址：</div>
                <div class="content">{{ dataInfos.address || '--' }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="basic box_card mt16" header="协会动态信息" shadow="never">
          <el-row>
            <el-col :span="8">
              <div class="child">
                            <div class="name">动态标题：</div>
                            <div class="content">{{ dataInfos.title || '--' }}</div>
                        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                            <div class="name">来源：</div>
                            <div class="content">{{dataInfos.source||'--'}}</div>
                        </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="child">
                            <div class="name">动态详情：</div>
                            <div class="content" v-html="dataInfos.content"></div>
                        </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content" v-if="dataInfos.fileList && dataInfos.fileList.length !== 0">
                            <li v-for="(item,i) in dataInfos.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                        </ul>
                    </div>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="basic box_card mt16"
          header="审核结果"
          shadow="never"
          v-if="tab === '2' && dataInfos.checkStatus !== 0"
        >
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核结果：</div>
                {{ (dataInfos.checkStatus | statusFilter) || '--' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核账号：</div>
                <div class="content">
                  {{ dataInfos.checkAccount || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核时间：</div>
                <div class="content">{{ dataInfos.checkTime || '--' }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">说明：</div>
                {{ dataInfos.auditInstructions || '--' }}
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
  components: {
    breadcrumb
  },
  filters: {
    statusFilter(status) {
      const statusMap = new Map([
        [-1, '未通过'],
        [0, '审核中'],
        [1, '已通过']
      ])
      return statusMap.get(status)
    }
  },
  data() {
    return {
      tab: '1', //选项卡
      id: '', //详情id
      dataInfos: {
        id: void 0,
        content: void 0,
        checkStatus: void 0,
        fileList:[]
      },
    }
  },
  methods: {
    //下载附件
    downLoad:function({filePath,fileName}){
    
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
    //获取数据
    async getData() {
      const { code, data, msg } = await this.$axiosc.get(`/backstage/announcement/findAnnouncementCheckDetails/${this.id}`)
      if (code == 200) {
        this.dataInfos = data
      } else {
        this.$alert(msg)
      }
    },
  },
  created() {
    const {id,tab} = this.$route.params
    this.id = id || void 0
    this.tab = tab || '1'
    if(id) this.getData()
  },
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
  // margin-top: 20px;
  &_card {
    border: none;
    &::v-deep {
      .el-card__header {
        font-size: 16px;
        color: #262626;
        padding: 14px 22px !important;
        border-bottom-color: #e5e5e5;
      }
      .el-card__body {
        padding: 24px 25px !important;
      }
    }
  }
}
.basic {
  color: $font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col {
    margin: 10px 0;
  }
  .child {
    color: #595959;
  }
}
.main {
  height:100%;
  overflow-x:hidden;
  overflow-y:auto;
  background: transparent !important;
  padding: 0 !important;
}
</style>
